import { useDrawerContext } from '../../contexts/drawer-context'

export const useDrawerProps = <T>(drawerId: string): T => {
  const { getDrawerProps } = useDrawerContext()

  const drawerProps = getDrawerProps(drawerId)

  return drawerProps as T
}
